import React, { useState } from 'react'
import Navbar from './_layout/navbar'
import Footer from './_layout/footer'
import { Button } from 'primereact/button'
import { useParams } from 'react-router-dom'
import { unsubscribeFromEmails } from '_services/users.service'

const Unsubscribe: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [isUnsubbed, setisUnsubbed] = useState<boolean>(false)

  const { id } = useParams()

  async function unsubscribeUser() {
    setLoading(true)
    await unsubscribeFromEmails(id,(_) => {
      setisUnsubbed(true)
    })
    setLoading(false)
  }

  return (
    <>
      <div className="header">
        <Navbar />
      </div>
      <main>
        <section>
          <div className="d-flex container justify-content-center">
            <div className="row">
              <div className="col">
                <h2 className="text-center"> "Unsubscribe"</h2>
                <hr className="title-border" />
                <br />
                <div className="container  justify-content-center">
                  <div className="row">
                 {isUnsubbed
                  ? <p>You've been Unsubscribed.</p>
                  : <>
                      <p>We’re sad to see you go! Looks like you’re unsubscribing from our love notes.</p>
                      <Button label="Unsubscribe from recieving emails" className="btn btn-primary" onClick={() => {unsubscribeUser()} } loading={loading}/>
                    </>
                  }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </>
  )
}

export default Unsubscribe
